// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.post-form__section[data-v-44bb8dad] {\n  position: relative;\n}\n.post-form__dialect-char-limit[data-v-44bb8dad] {\n  position: absolute;\n  top: 57px;\n  left: 18px;\n  left: 0;\n  font-size: 12px;\n}\n.description-optional-text[data-v-44bb8dad] {\n  font-size: 9px;\n}\n", ""]);
// Exports
module.exports = exports;
